import React, { useEffect, useState } from "react";
import { FaStar, FaClock, FaLanguage, FaMoneyBillWave } from "react-icons/fa";
import SummaryApi from "../common";
import { PiStarFourFill } from "react-icons/pi";

import noimage from "../asset/noimage.png";
import noSavedCourses from "../asset/nosavedcourses.png"; // <-- same path, use your "No Saved Courses" image
import { FaBookmark } from "react-icons/fa";
import Swal from "sweetalert2";
import { RiBookmarkLine, RiShareBoxLine } from "react-icons/ri";
import { useAuth } from "../helpers/AuthContext";
const SavedCourses = () => {
  const [savedCourses, setSavedCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const [savedCourseIds, setSavedCourseIds] = useState([]);

 const { studentId, studentName, studentEmail } = useAuth();
  useEffect(() => {
    const fetchSavedCourses = async () => {
      try {
        const response = await fetch(SummaryApi.getSavedcourseStudentId.url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ student_id: studentId }),
        });

        const result = await response.json();

        if (result.status) {
          setSavedCourses(result.data);
        } else {
          console.error("Error fetching courses");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedCourses();
  }, [studentId]);

  useEffect(() => {
    if (studentId) {
      fetch(SummaryApi.getSavedcourseStudentId.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_id: studentId }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status && data.data) {
            setSavedCourseIds(data.data); // Save entire saved course objects
          }
        })
        .catch((err) => console.error("Failed to fetch saved courses:", err));
    }
  }, [studentId]);

  const handleSaveCourse = (course_id) => {
    if (!studentId) {
      Swal.fire({
        icon: "warning",
        title: "Please log in first",
        text: "You need to be logged in to save courses.",
      });
      return;
    }

    if (savedCourseIds.find((c) => c.course_id === course_id)) {
      Swal.fire({
        icon: "info",
        title: "Already Saved",
        text: "This course is already in your saved list.",
      });
      return;
    }

    fetch(SummaryApi.SaveCourseToStudent.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ student_id: studentId, course_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSavedCourseIds((prev) => [
            ...prev,
            { course_id, saved_course_id: data.saved_course_id },
          ]);

          Swal.fire({
            icon: "success",
            title: "Course Saved",
            text: "The course has been added to your saved list.",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Save Failed",
            text: data.message || "Failed to save the course.",
          });
        }
      })
      .catch((err) => {
        console.error("Error saving course:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while saving the course.",
        });
      });
  };

  const handleDeleteSavedCourse = (course_id) => {
    const savedCourse = savedCourseIds.find((c) => c.course_id === course_id);
    if (!savedCourse) return;

    fetch(SummaryApi.DeleteSavedCourse.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ saved_course_id: savedCourse.saved_course_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSavedCourseIds((prev) =>
            prev.filter((c) => c.course_id !== course_id)
          );

          Swal.fire({
            icon: "success",
            title: "Course Removed",
            text: "The course has been removed from your saved list.",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Remove Failed",
            text: data.message || "Failed to remove the saved course.",
          });
        }
      })
      .catch((err) => {
        console.error("Error deleting saved course:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while removing the saved course.",
        });
      });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-center text-lg text-gray-600 dark:text-gray-300">
        Loading saved courses...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center p-4 sm:p-6 lg:p-8">
      {/* If no saved courses, show centered image outside the grid */}
       
      {savedCourses.length === 0 ? (
        <div className="flex flex-col justify-center items-center w-full flex-grow">
                  <h1 className="text-2xl sm:text-3xl font-bold text-[#1f4774] dark:text-white mb-6 text-center">
              My Saved Courses
        </h1>
          <img
            src={noSavedCourses}
            alt="No Saved Courses"
            className="w-full max-w-[220px] sm:max-w-[280px] md:max-w-[340px] h-auto object-contain"
          />
        </div>
      ) : (
        // Otherwise show the grid layout as it is
        <div className="w-full max-w-7xl mx-auto flex-grow">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="w-full">
      
        <h1 className="text-2xl sm:text-3xl font-bold text-[#1f4774] dark:text-white mb-6 text-center">
          My Saved Courses
        </h1>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {savedCourses.map((course) => (
                  <div
                    key={course.saved_course_id}
                    className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
                  >
                    {/* Course Image */}
                    <img
                      className="w-full h-48 object-cover"
                      src={
                        course.course_image1
                          ? `${SummaryApi.instructorCourseImage.url.replace(
                              "api",
                              ""
                            )}${course.course_image1.replace("/api", "")}`
                          : noimage
                      }
                      alt={course.course_title}
                    />

                    <div className="p-4">
                      <h3 className="text-xl font-bold text-[#1c3664] dark:text-white mb-4 group-hover:text-[#100F36] transition-colors duration-300 line-clamp-2 min-h-[1.5rem]">
                        {course.course_title}
                      </h3>
                      <div className="flex items-center text-sm text-gray-600 dark:text-gray-300 mb-4">
                        <div className="flex items-center text-yellow-600 dark:text-yellow-400 font-semibold mr-4 bg-yellow-50 dark:bg-yellow-900 px-3 py-1 rounded-full">
                          <FaStar className="w-4 h-4 mr-1" />
                          {course.rating}
                        </div>
                        <div className="flex items-center space-x-2 ml-auto">
                          {savedCourseIds.find(
                            (c) => c.course_id === course.course_id
                          ) ? (
                            <FaBookmark
                              className="w-6 h-6 text-green-600 dark:text-green-400 cursor-pointer"
                              title="Remove Saved Course"
                              onClick={() =>
                                handleDeleteSavedCourse(course.course_id)
                              }
                            />
                          ) : (
                            <RiBookmarkLine
                              className="w-6 h-6 text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer"
                              title="Save Course"
                              onClick={() => handleSaveCourse(course.course_id)}
                            />
                          )}

                          <RiShareBoxLine className="w-6 h-6 text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer" />
                        </div>
                      </div>

                      <div className="flex items-center text-sm text-gray-700 dark:text-gray-200 mb-2 space-x-4 justify-between">
                        <span className="flex items-center">
                          <FaClock className="mr-1 text-blue-500 dark:text-blue-400" />{" "}
                          {course.course_duration}
                        </span>
                        <span className="text-green-600 dark:text-green-400 font-bold flex items-center">
                          <FaMoneyBillWave className="mr-1" /> ₹
                          {course.total_price}
                        </span>
                      </div>

                      {/* <a
                        href={course.course_video_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-4 inline-block text-blue-600 hover:underline text-sm"
                      >
                        Watch Preview
                      </a> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );



};

export default SavedCourses;